module.exports = __webpack_public_path__ + "static/press-brakes-new-92f119ec596282460acad99c05fb7d51.jpg";